import { ref as i, onUnmounted as c, defineComponent as d, unref as m, renderSlot as u, createCommentVNode as a } from "vue";
import { DEFAULT_BREAKPOINTS as l } from "./constant/breakpoints.js";
function f({ target: t, breakpoints: e }) {
  e = e || l;
  const n = t.slice(0, -1), o = t.slice(-1) === "+", r = t.slice(-1) === "-";
  return e[n] && o ? `(min-width: ${e[n]}px)` : e[n] && r ? `(max-width: ${e[n] - 0.02}px)` : "";
}
function h(t) {
  const e = i(!1), n = window.matchMedia(f(t));
  e.value = n.matches;
  const o = (r) => {
    e.value = r.matches;
  };
  return n.addEventListener("change", o), c(() => {
    n.removeEventListener("change", o);
  }), e;
}
const _ = /* @__PURE__ */ d({
  name: "e-mq",
  __name: "media-query",
  props: {
    target: {},
    breakpoints: {}
  },
  setup(t) {
    const n = h(t);
    return (o, r) => m(n) ? u(o.$slots, "default", { key: 0 }) : a("", !0);
  }
});
export {
  _ as default
};
//# sourceMappingURL=media-query.js.map
